import React from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import { useMobileAuth } from './contexts/MobileAuthContext'
import { useDarkMode } from './utils/useDarkMode'
import QRLoginPage from './pages/QRLoginPage'
import DashboardPage from './pages/DashboardPage'
import IncidencesPage from './pages/IncidencesPage'

const pageTransition = {
  initial: { opacity: 0, x: 24 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -24 },
}

const AnimatedPage = ({ children }) => (
  <motion.div
    className="h-full"
    variants={pageTransition}
    initial="initial"
    animate="animate"
    exit="exit"
    transition={{ duration: 0.22, ease: 'easeOut' }}
  >
    {children}
  </motion.div>
)

const App = () => {
  const { isAuthenticated } = useMobileAuth()
  const { isDarkMode, toggleDarkMode } = useDarkMode()
  const location = useLocation()

  return (
    <div className="h-full overflow-hidden bg-white dark:bg-gray-900">
      <AnimatePresence mode="wait" initial={false}>
        <Routes location={location} key={location.pathname}>
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/dashboard" replace />
              ) : (
                <AnimatedPage><QRLoginPage /></AnimatedPage>
              )
            }
          />
          <Route
            path="/dashboard"
            element={
              isAuthenticated ? (
                <AnimatedPage>
                  <DashboardPage isDarkMode={isDarkMode} toggleDarkMode={toggleDarkMode} />
                </AnimatedPage>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route
            path="/incidencias/:integrationId"
            element={
              isAuthenticated ? (
                <AnimatedPage><IncidencesPage /></AnimatedPage>
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          <Route path="*"element={<Navigate to={isAuthenticated ? '/dashboard' : '/login'} replace />} />
        </Routes>
      </AnimatePresence>
    </div>
  )
}

export default App
